import React from 'react'
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Alert
} from '@mui/material'
import { Pool as PoolIcon } from '@mui/icons-material'
import { usePool } from '../../contexts/PoolContext'

const PoolSelector = ({ 
  selectedPool, 
  onPoolChange, 
  label = "Pool",
  showAlert = true,
  fullWidth = true 
}) => {
  const { pools } = usePool()

  const handleChange = (event) => {
    const poolId = event.target.value
    const pool = pools.find(p => p.id === poolId)
    onPoolChange(pool)
  }

  return (
    <Box>
      <FormControl fullWidth={fullWidth} variant="outlined">
        <InputLabel id="pool-select-label">{label}</InputLabel>
        <Select
          labelId="pool-select-label"
          value={selectedPool?.id || ''}
          onChange={handleChange}
          label={label}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            }
          }}
        >
          {pools.map((pool) => (
            <MenuItem key={pool.id} value={pool.id}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PoolIcon fontSize="small" color="action" />
                <Box>
                  <Typography variant="body1">{pool.name}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {pool.volume_gallons?.toLocaleString()} gallons • {pool.pool_type?.replace('_', ' ')}
                  </Typography>
                </Box>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {showAlert && !selectedPool && pools.length > 0 && (
        <Alert severity="info" sx={{ borderRadius: 2, mt: 2 }}>
          Please select a pool to continue.
        </Alert>
      )}
    </Box>
  )
}

export default PoolSelector